import { useContext } from 'react';
import { CartContext } from '../context/CartContext';
import { Link } from 'react-router-dom';
import './CartPopup.css';

const CartPopup = () => {
  const {
    cartItems,
    showCart,
    toggleCart,
    updateCartItem,
    removeFromCart
  } = useContext(CartContext);

  if (!showCart) return null;

  const sizeOptions = [
    'Plugs', '10cm', '1-gallon', '2-gallon', '3-gallon', '5-gallon', '10-gallon'
  ];

  return (
    <div className="cart-popup">
      <div className="cart-popup-inner">
        <button className="close-btn" onClick={toggleCart}>×</button>
        <h3>Your Cart</h3>

        {cartItems.length === 0 ? (
          <p>No items in cart.</p>
        ) : (
          <div className="cart-table">
            <div className="cart-header">
              <span className="col-name">Product</span>
              <span className="col-size">Size</span>
              <span className="col-qty">Qty</span>
              <span className="col-remove"></span>
            </div>

            <div className="cart-body">
              {cartItems.map((item, idx) => (
                <div className="cart-row" key={idx}>
                  <span className="col-name">{item.name}</span>

                  <span className="col-size">
                    <select
                      value={item.size || ''}
                      onChange={(e) =>
                        updateCartItem(idx, {
                          ...item,
                          size: e.target.value
                        })
                      }
                    >
                      <option value="" disabled>Select Size</option>
                      {sizeOptions.map((size, i) => (
                        <option key={i} value={size}>{size}</option>
                      ))}
                    </select>
                  </span>

                  <span className="col-qty">
                    <input
                      type="number"
                      min="1"
                      value={item.quantity}
                      onChange={(e) =>
                        updateCartItem(idx, {
                          ...item,
                          quantity: Math.max(1, parseInt(e.target.value) || 1)
                        })
                      }
                    />
                  </span>

                  <span className="col-remove">
                    <button
                      className="remove-btn"
                      onClick={() => removeFromCart(idx)}
                    >
                      ×
                    </button>
                  </span>
                </div>
              ))}
            </div>

            <div className="request-quote-link">
              <Link to="/request-quote" className="request-quote-btn" onClick={toggleCart}>
                Request Quote
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CartPopup;
